export interface PersonCount {
  personType: { id: string };
  count: number;
}

export const personCountFields = `
  personType { id }
  count
`;

export interface CodeCount {
  election: { id: string };
  voters: number;
  codes: number;
  assignedCodes: number;
}

export const codeCountFields = `
  election { id }
  voters
  codes
  assignedCodes
`;
